/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import ProductSlider from "./ProductSlider";
import BrokeragePricing from "./BrokeragePricing";
import WhyWealthyBroking from "./WhyWealthyBroking";
import BrokingBannerCta from "./BrokingBannerCta";
import BrokingFaqs from "./BrokingFaqs";
import GetStartedCta from "./GetStartedCta";
import HeroBanner from "./HeroBanner";

export {
  ProductSlider,
  BrokeragePricing,
  WhyWealthyBroking,
  BrokingBannerCta,
  BrokingFaqs,
  GetStartedCta,
  HeroBanner
};
